#import "../fragments/contact-duplicate-fragment.graphql"

query GetContactDuplicateStatus($id: ID!) {
    contact(id: $id) {
        ...ContactDuplicateFragment
    }
}
